import { render, staticRenderFns } from "./EventCopyOverlay.vue?vue&type=template&id=7e3613f4&scoped=true&"
import script from "./EventCopyOverlay.vue?vue&type=script&lang=js&"
export * from "./EventCopyOverlay.vue?vue&type=script&lang=js&"
import style0 from "./EventCopyOverlay.vue?vue&type=style&index=0&id=7e3613f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e3613f4",
  null
  
)

export default component.exports